export const STATUS_LOADING = 0;
export const STATUS_SEARCH = 1;
export const STATUS_VALID = 2;
export const STATUS_INVALID = 3;
export const STATUS_UPDATE = 4;
export const STATUS_NOT_FOUND = 5;
export const STATUS_VALID_PRE_ENTERED = 6;
export const STATUS_CREATE = 7;
